import React from 'react';
import { Box, SimpleGrid, Container } from '@hover/blueprint';
import Header from './Header';
import Quote from './Quote';
import Video from './Video';

const CaseStudy: React.FC = () => (
  <Box
    w="100%"
    bg="brandNavy.100"
    justifyContent="center"
    pt={{ base: 700, desktop: '87px' }}
    pb={{ base: 700, desktop: 1000 }}
    mb={1000}
  >
    <Container
      d="flex"
      px={500}
      maxW={{ base: '2xl', desktop: '1248px' }}
      flexDir="column"
      alignItems="flex-start"
    >
      <Header />
      <SimpleGrid columns={{ base: 1, desktop: 2 }} spacing={800}>
        <Quote />
        <Video />
      </SimpleGrid>
    </Container>
  </Box>
);

export default CaseStudy;
